import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InteractiveElement } from "@iventis/styles/src/components";
import { Subtitle } from "@iventis/styles/src/components/texts";
import { Content } from "@iventis/translations/content/typed-content";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { MapGlobalState } from "@iventis/map-engine/src/state/map.state.types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@iventis/styles";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { map } from "./state/map.slice";
import { sidebar } from "./state/sidebar.slice";
import { SidebarState } from "./state/sidebar.slice.types";
import { StyledSelectorPopover } from "./sitemap-selector";

export const LevelSelectorComponent = () => {
    const dispatch = useDispatch();
    const { levels, selectedLevelIndex, isPlacingGeometry } = useSelector(
        ({ mapReducer }: { mapReducer: MapGlobalState }) => ({
            // Array is frozen in strict mode so need to copy before sorting.
            // Sort in reverse so the lower value indexes are at the bottom.
            levels: [...mapReducer.levels].sort((levelA, levelB) => levelB.index - levelA.index),
            selectedLevelIndex: mapReducer.mapModule.currentLevel,
            isPlacingGeometry: mapReducer.isPlacingGeometry,
        }),
        (prev, next) => prev.selectedLevelIndex === next.selectedLevelIndex && prev.levels.length === next.levels.length && prev.isPlacingGeometry === next.isPlacingGeometry
    );
    const fullScreenSelector = useSelector(({ sidebarReducer }: { sidebarReducer: SidebarState }) => sidebarReducer.fullScreenSelector);

    const translate = useIventisTranslate();

    const handleLevelChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(map.actions.updateSelectedLevel(parseInt(event.target.value, 10)));
        // Close the popover after selecting a level while placing geometry (e.g. duplicating objects).
        // This allows the user to continue placing the object without having to refocus on the canvas
        if (isPlacingGeometry) {
            dispatch(sidebar.actions.closePopover());
        }
    };

    return (
        <StyledSelectorPopover>
            <Subtitle>{translate(Content.map.popup.sitemapLevels)}</Subtitle>
            {fullScreenSelector && (
                <StyledCloseButton onClick={() => dispatch(sidebar.actions.setFullScreenSelector(null))}>
                    <FontAwesomeIcon icon="xmark" />
                    <span className="hidden">{translate(Content.map.popup.closeLevelSelector)}</span>
                </StyledCloseButton>
            )}

            <RadioGroup aria-label="Levels" value={selectedLevelIndex} onChange={handleLevelChange}>
                {levels.map((level) => (
                    <FormControlLabel key={level.index} value={level.index} control={<Radio size="small" data-testid={`level-${level.name}`} />} label={level.name} />
                ))}
            </RadioGroup>
        </StyledSelectorPopover>
    );
};

const StyledCloseButton = styled(InteractiveElement)`
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;
`;
